import type { FaireProductEntity } from "../../entity_types/product";

export const p_v8h4xykzkx: FaireProductEntity = {
  token: "p_v8h4xykzkx",
  type: "product",
  name: "Triple Fat Cacao Powder, 100% Cacao - Organic & Regenerative",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/3fd1e50c0d72e863832d9dab6b7a005249114eacf24ce99ad96d1a2bab50da67.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08ee903ea4408ee72ca90678438896316438cf71a1d4f5b7e0b0f720bed718fd.png",
    "https://cdn.faire.com/fastly/4372fb10fe75e30ef7bf1ee77387b79002100553cab601d9530755bcb0f4765c.png",
    "https://cdn.faire.com/fastly/04b7cd066a05590d37799de93dda3b2cbda5fad254a8a03f40e8c3d50dab29c4.png",
  ],
  priceDollars: 16,
  description:
    "This cacao powder is a serious upgrade from what you can find in most stores. It's made from premium beans with 30% naturally occurring fat, which is three times the fat content of regular cacao powder. This is so important because the fat is essential for making the antioxidants and minerals in cacao bioavailable. \n\nThis cacao powder is direct trade and traceable to 200 individual farmers from a regenerative and organic project outside of Cusco, Peru. Many of the farms and the association are run by indigenous Koribeni and Kiteni women, who put their love and care into the stewardship of this cacao and the Amazon it calls home.\n\nIt's rich, decadent flavor makes it perfect for smoothies, baking, or hot chocolate. \nLab tested for heavy metals safety.\n\nNote: we also have a bulk size, not in tins. This is listed separately.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:39.974Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
